// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GoTo$LiveRoom from "../../GoTo.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as Utils_Auction$LiveRoom from "../../Utils/Utils_Auction.bs.js";
import * as Utils_Session$LiveRoom from "../../Utils/Utils_Session.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function sessionTitle(session, t2) {
  return Belt_Option.mapWithDefault(session, "", (function (session) {
                return Utils_Session$LiveRoom.getSessionName(session.title, session.sessionId, t2);
              }));
}

function BetweenSessionModalV2$ModalDescriptionText(props) {
  var nextSession = props.nextSession;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t2 = match.t2;
  var match$1 = nextSession !== undefined ? Utils_Session$LiveRoom.getNextSessionTimeV2(nextSession.scheduledOpeningDate, match.t) : [
      "",
      "LotCloseTime"
    ];
  var auctionName = Belt_Option.getWithDefault(props.auctionTitle, "");
  var closedSessionTitle = sessionTitle(props.closedSession, t2);
  var nextSessionTitle = sessionTitle(nextSession, t2);
  var nextSessionFromLotNr = nextSession !== undefined ? String(Belt_Option.mapWithDefault(nextSession.lotRange, 0, (function (x) {
                return x.fromLotNr;
              }))) : "";
  var description = match$1[1] === "TimeReached" ? Curry._2(t2, "BetweenSessionFeed_sessionConcludedWillBeginShortly", {
          currentSession: closedSessionTitle,
          auctionName: auctionName,
          nextSession: nextSessionTitle,
          lotNr: nextSessionFromLotNr
        }) : Curry._2(t2, "BetweenSessionFeed_sessionConcludedWillBeginAt", {
          currentSession: closedSessionTitle,
          auctionName: auctionName,
          nextSession: nextSessionTitle,
          time: match$1[0],
          lotNr: nextSessionFromLotNr
        });
  return React.createElement(SterlingTypography$LiveRoom.Paragraph18Regular.make, {
              className: Curry._1(Css.style, {
                    hd: Css.marginBottom(Css.px(40)),
                    tl: {
                      hd: Css.important(Css.fontWeight({
                                NAME: "num",
                                VAL: 400
                              })),
                      tl: /* [] */0
                    }
                  }),
              children: description
            });
}

var ModalDescriptionText = {
  make: BetweenSessionModalV2$ModalDescriptionText
};

function BetweenSessionModalV2$ModalContent(props) {
  var auctionSlug = props.auctionSlug;
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(React.Fragment, undefined, React.createElement(BetweenSessionModalV2$ModalDescriptionText, {
                  auctionTitle: props.auctionTitle,
                  closedSession: props.closedSession,
                  nextSession: props.nextSession
                }), React.createElement(Button.Button, {
                  onClick: (function (param) {
                      GoTo$LiveRoom.auctionDetails(Utils_Auction$LiveRoom.getAuctionUrl(auctionSlug.name, auctionSlug.year, undefined, undefined));
                    }),
                  className: Curry._1(Css.style, {
                        hd: Css.important(Css.width("auto")),
                        tl: {
                          hd: Css.marginLeft("auto"),
                          tl: {
                            hd: Css.marginRight("auto"),
                            tl: /* [] */0
                          }
                        }
                      }),
                  children: Curry._1(match.t, "BetweenSessionModal_returnToAuctionPage")
                }));
}

var ModalContent = {
  make: BetweenSessionModalV2$ModalContent
};

function BetweenSessionModalV2(props) {
  var queryResult = Curry.app(ClientapiQueries$LiveRoom.BetweenSessionModal.BetweenSessionModalQuery.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        Curry._2(ClientapiQueries$LiveRoom.BetweenSessionModal.BetweenSessionModalQuery.makeVariables, props.auctionId, undefined)
      ]);
  var match = I18next$LiveRoom.useTranslation(undefined);
  var match$1 = queryResult.data;
  var t2 = match.t2;
  if (match$1 === undefined) {
    return null;
  }
  var auction = match$1.auction;
  if (auction === undefined) {
    return null;
  }
  var isSessionOpen = Belt_Array.some(auction.sessions, (function (s) {
          return s.state.state === "Open";
        }));
  var closedSession = Belt_Array.getBy(Belt_Array.reverse(auction.sessions), (function (s) {
          return s.state.state === "Closed";
        }));
  var nextSession = Belt_Array.getBy(auction.sessions, (function (s) {
          return s.state.state === "PreOpen";
        }));
  var modalTitle = closedSession !== undefined ? (
      props.comingIntoBetweenSession ? Curry._1(match.t, "Common_auctionRoomLoginPrompHeader") : Curry._2(t2, "BetweenSessionModal_sessionEnded", {
              sessionName: Utils_Session$LiveRoom.getSessionName(closedSession.title, closedSession.sessionId, t2)
            })
    ) : "";
  if (Belt_Option.isSome(nextSession) && !isSessionOpen) {
    return React.createElement(SterlingModal$LiveRoom.Modal.make, {
                children: React.createElement(SterlingModal$LiveRoom.Content.make, {
                      children: React.createElement(BetweenSessionModalV2$ModalContent, {
                            auctionTitle: auction.title,
                            auctionSlug: auction.slug,
                            closedSession: closedSession,
                            nextSession: nextSession
                          }),
                      className: Curry._1(Css.style, {
                            hd: Css.margin2(Css.px(16), Css.px(0)),
                            tl: /* [] */0
                          })
                    }),
                className: Curry._1(Css.style, {
                      hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                            hd: Css.width(Css.pct(100)),
                            tl: {
                              hd: Css.height(Css.pct(100)),
                              tl: {
                                hd: Css.important(Css.maxHeight(Css.pct(100))),
                                tl: {
                                  hd: Css.important(Css.maxWidth(Css.pct(100))),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }),
                      tl: /* [] */0
                    }),
                onClose: props.closeModal,
                isOpen: true,
                headerTitle: modalTitle,
                closeOnOutsideClick: true
              });
  } else {
    return null;
  }
}

var SessionStateFragment = ClientapiQueries$LiveRoom.BetweenSessionModal.SessionStateFragment;

var BetweenSessionModalQuery = ClientapiQueries$LiveRoom.BetweenSessionModal.BetweenSessionModalQuery;

var make = BetweenSessionModalV2;

export {
  SessionStateFragment ,
  BetweenSessionModalQuery ,
  sessionTitle ,
  ModalDescriptionText ,
  ModalContent ,
  make ,
}
/* Css Not a pure module */
